var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.999,
    height: 27,
    viewBox: "0 0 23.999 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1356",
    "data-name": "Group 1356",
    transform: "translate(-1664.001 -148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_28",
    "data-name": 28,
    transform: "translate(1660.586 148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M25.424,20.443l-1.527-2.2a1.785,1.785,0,0,1-.321-1.018v-6.3a8.927,8.927,0,1,0-17.854,0v6.3A1.785,1.785,0,0,1,5.4,18.247l-1.527,2.2A1.785,1.785,0,0,0,5.2,23.425h5.079a4.463,4.463,0,0,0,8.748,0H24.1a1.785,1.785,0,0,0,1.321-2.982ZM14.65,25.21a2.678,2.678,0,0,1-2.517-1.785h5.035A2.678,2.678,0,0,1,14.65,25.21ZM5.2,21.639a.723.723,0,0,0,.107-.125l1.562-2.25a3.571,3.571,0,0,0,.643-2.035v-6.3a7.142,7.142,0,1,1,14.283,0v6.3a3.571,3.571,0,0,0,.643,2.035L24,21.514a.723.723,0,0,0,.107.125Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    transform: "translate(1678 148)",
    fill: "#ee4130",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.5ba71469814cc9947c4ac7a0246a919b.svg";
export { ForwardRef as ReactComponent };